import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import gql from 'graphql-tag';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {openMsg, loadingModal} from 'src/redux-app';
import {hooks} from 'lib.front';
const {useApolloQ} = hooks;

const query = gql`
   query getData {
      clienteProductos {
         cliente {
            nombre
            apPaterno
            apMaterno
            razonSocial
            nroDoc
         }
         producto {
            codigo
            denominacion
            familia {
               codigo
               denominacion
            }
            activo
         }
         fechaHora
      }
   }
`;

const query2 = gql`
   query getData2 {
      asesores {
         codigo
         nombre
         apPaterno
         sucursal {
            codigo
            denominacion
         }
      }
   }
`;
export default function PruebaHooks(props) {
   const dispatch = useDispatch();
   //Modal de espera
   function openWaitModal(load) {
      dispatch(loadingModal(load));
   }
   //Modal para mensajes
   function openMsgModal(msg) {
      dispatch(openMsg(msg));
   }

   function msgError(err) {
      openMsgModal(JSON.stringify(err));
   }
   const {data} = useApolloQ(query, {callbackError: msgError, callbackLoading: openWaitModal});
   const {data: data2} = useApolloQ(query2, {
      callbackError: msgError,
      callbackLoading: openWaitModal
   });

   return (
      <Grid container spacing={2}>
         <Grid item xs={12}>
            <Typography variant="h3">Prueba</Typography>
         </Grid>
         <Grid item xs={12}>
            <Typography variant="h4">Sucursales</Typography>
         </Grid>
         <Grid item xs={12}>
            {data2 !== undefined && JSON.stringify(data2)}
         </Grid>
         <Grid item xs={12}>
            <Typography variant="h4">Clientes</Typography>
         </Grid>
         <Grid item xs={12}>
            {data !== undefined && JSON.stringify(data)}
         </Grid>
      </Grid>
   );
}
